import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

import Loader from '../../components/Common/Loader';
import PlcSafetyTriggerList from '../../components/Lists/PlcSafetyTriggerList';
import { getPlcSafetyTriggers } from '../../store/actions';

class PlcSafetyTriggers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      triggerList: null,
    };
  }

  componentDidMount() {
    this.props.getPlcSafetyTriggers(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.triggers !== prevProps.triggers) {
      this.setState({ triggerList: this.props.triggers });
    }
  }

  refresh(event) {
    event.preventDefault();
    this.setState({ triggerList: null });
    this.props.getPlcSafetyTriggers(this.state.user);
  }

  render() {
    if (!this.state.triggerList) {
      return (
        <div className="loaderCenter">
          <Loader></Loader>
        </div>
      );
    }
    return (
      <div className="user-management">
        <Container fluid>
          <Button
            onClick={(event) => this.refresh(event)}
            color="primary"
            className="btn btn-primary buttonStatus usersButtons"
          >
            <i size="lg" className="mdi mdi-refresh"></i>
          </Button>
          <Button className="btn btn-primary waves-effect waves-light buttonStatus usersButtons">
            <Link to="/createPlcSafetyTrigger">{this.props.t('Crear trigger')}</Link>
          </Button>
          <Button className="btn btn-secondary waves-effect waves-light buttonStatus usersButtons">
            <Link to="/plcSafetyEvents">{this.props.t('Ver eventos')}</Link>
          </Button>
          <PlcSafetyTriggerList triggerList={this.state.triggerList} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { triggers } = state.getPlcSafetyTriggers;
  return { triggers };
};

export default withRouter(connect(mapStateToProps, { getPlcSafetyTriggers })(withNamespaces()(PlcSafetyTriggers)));
